import { render, staticRenderFns } from "./GreenProduct.vue?vue&type=template&id=f58e6a36&scoped=true&"
import script from "./GreenProduct.vue?vue&type=script&lang=ts&"
export * from "./GreenProduct.vue?vue&type=script&lang=ts&"
import style0 from "./GreenProduct.vue?vue&type=style&index=0&id=f58e6a36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f58e6a36",
  null
  
)

export default component.exports